import React from 'react';
import { Target, Compass, Heart } from 'lucide-react';
export const About = () => {
  return <section id="about" className="py-16 md:py-24 bg-white" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-17">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-18">
            About Life Fort Solutions
          </h2>
          <p className="text-lg text-gray-600" data-id="element-19">
            Founded in 2019, we're a boutique strategy management firm dedicated
            to helping individuals and organizations navigate complexity and
            achieve extraordinary results.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8 max-w-5xl mx-auto" data-id="element-20">
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-21">
            <div className="bg-blue-800 rounded-full w-12 h-12 flex items-center justify-center mb-6" data-id="element-22">
              <Compass className="text-white" size={24} data-id="element-23" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-24">
              Our Mission
            </h3>
            <p className="text-gray-600" data-id="element-25">
              To empower visionaries with strategic clarity and execution
              excellence, transforming ambitious ideas into tangible success
              stories across Africa and beyond.
            </p>
          </div>
          <div className="bg-amber-50 p-8 rounded-lg" data-id="element-26">
            <div className="bg-amber-500 rounded-full w-12 h-12 flex items-center justify-center mb-6" data-id="element-27">
              <Target className="text-white" size={24} data-id="element-28" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-29">Our Vision</h3>
            <p className="text-gray-600" data-id="element-30">
              To be the catalyst for a new era of African excellence, where
              innovative ideas are strategically implemented to create global
              impact and lasting legacy.
            </p>
          </div>
          <div className="bg-blue-50 p-8 rounded-lg" data-id="element-31">
            <div className="bg-blue-800 rounded-full w-12 h-12 flex items-center justify-center mb-6" data-id="element-32">
              <Heart className="text-white" size={24} data-id="element-33" />
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3" data-id="element-34">
              Core Values
            </h3>
            <ul className="text-gray-600 space-y-2" data-id="element-35">
              <li data-id="element-36">• Excellence in everything we do</li>
              <li data-id="element-37">• Integrity and transparency</li>
              <li data-id="element-38">• Client-centered approach</li>
              <li data-id="element-39">• Innovation with purpose</li>
              <li data-id="element-40">• Cultural intelligence</li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
};